// extracted by mini-css-extract-plugin
export default {"asideCefX":"styles_asideCefX__FlmTa","tiposDePontos":"styles_tiposDePontos__58HSU","wrapper_tiposDePontos":"styles_wrapper_tiposDePontos__U7OA9","point":"styles_point__EzSQO"};